export const ADD_PARTICIPANTS_REMINDERS = "ADD_PARTICIPANTS_REMINDERS"
export const EDIT_PARTICIPANTS_REMINDERS = "EDIT_PARTICIPANTS_REMINDERS"
export const LIST_PARTICIPANTS_REMINDERS = "LIST_PARTICIPANTS_REMINDERS"
export const VIEW_PARTICIPANTS_REMINDERS = "VIEW_PARTICIPANTS_REMINDERS"
export const DELETE_PARTICIPANTS_REMINDERS = "DELETE_PARTICIPANTS_REMINDERS"

// Text
export const ADD_PARTICIPANTS_REMINDERS_TEXT = "ADD_PARTICIPANTS_REMINDERS_TEXT"
export const EDIT_PARTICIPANTS_REMINDERS_TEXT = "EDIT_PARTICIPANTS_REMINDERS_TEXT"
export const LIST_PARTICIPANTS_REMINDERS_TEXT = "LIST_PARTICIPANTS_REMINDERS_TEXT"
export const VIEW_PARTICIPANTS_REMINDERS_TEXT = "VIEW_PARTICIPANTS_REMINDERS_TEXT"
export const DELETE_PARTICIPANTS_REMINDERS_TEXT = "DELETE_PARTICIPANTS_REMINDERS_TEXT"

export const PARTICIPANTS_REMINDERS_SUCCESS = "PARTICIPANTS_REMINDERS_SUCCESS"
export const PARTICIPANTS_REMINDERS_ERROR = "PARTICIPANTS_REMINDERS_ERROR"

